import { Children, cloneElement } from 'react'
import cx from 'classnames'

import './style.scss'

export const List = ({
  children,
  className,
  selectable = false,
  activeIndex = 0,
  onSelect = (_index: number) => {},
  border = true,
}: {
  children?: any
  className?: string
  selectable?: boolean
  activeIndex?: number
  onSelect?: Function
  border?: boolean
}) => {
  return (
    <div
      className={cx('List', {
        'List--border': border,
        [className]: className,
      })}
    >
      {Children.map(
        children,
        (child, index) =>
          child &&
          cloneElement(child, {
            index,
            selectable,
            selected: index === activeIndex,
            onSelect: () => {
              onSelect(index)
            },
            ...(child.props || {}),
          })
      )}
    </div>
  )
}
